var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"select-none fixed top-0 left-0 p-5 z-50 cursor-pointer link",class:{ 'opacity-0': _vm.hide },on:{"click":function($event){_vm.$root.$emit('goToAbout'); _vm.$root.$emit('resetAbout');}}},[_vm._v(" Omnigroup ")])}
var staticRenderFns = []

export { render, staticRenderFns }